// extracted by mini-css-extract-plugin
export default {"styled-menu-btn":"Burger_styled-menu-btn__Y1h6h"};